import styled from 'styled-components';

export default styled.h2`
  font-size: '2.9rem';
  padding-top: 2rem;
  margin-bottom: 1rem;

  @media (width >= 701px) {
    padding-top: 0;
  }
`;
